export interface AdjustmentsParams {
  brightness: number
  contrast: number
  saturation: number
}

export enum AdjustmentChannel {
  Brightness = 'brightness',
  Contrast = 'contrast',
  Saturation = 'saturation',
}

export const ADJUSTMENTS_UNSUPPORTED_MESSAGE = 'Adjustments need canvas filters; this browser lacks them'

export const ADJUSTMENT_RANGE = {
  min: -100,
  max: 100,
} as const

export const IDENTITY_ADJUSTMENTS: Readonly<AdjustmentsParams> = {
  brightness: 0,
  contrast: 0,
  saturation: 0,
}

export function validateAdjustmentConfiguration(): void {
  if (!Number.isFinite(ADJUSTMENT_RANGE.min)
    || !Number.isFinite(ADJUSTMENT_RANGE.max)
    || ADJUSTMENT_RANGE.min >= 0
    || ADJUSTMENT_RANGE.max <= 0
    || ADJUSTMENT_RANGE.min >= ADJUSTMENT_RANGE.max) {
    throw new Error('Adjustment range must contain zero between finite minimum and maximum values')
  }
}

export function assertAdjustmentsParams(params: AdjustmentsParams): void {
  const values: ReadonlyArray<readonly [keyof AdjustmentsParams, number]> = [
    ['brightness', params.brightness],
    ['contrast', params.contrast],
    ['saturation', params.saturation],
  ]
  for (const [name, value] of values) {
    if (!Number.isFinite(value)
      || value < ADJUSTMENT_RANGE.min
      || value > ADJUSTMENT_RANGE.max) {
      throw new Error(
        `Adjustment ${name} must be from ${ADJUSTMENT_RANGE.min} to ${ADJUSTMENT_RANGE.max}`,
      )
    }
  }
}

export function isIdentityAdjustments(params: AdjustmentsParams): boolean {
  return params.brightness === IDENTITY_ADJUSTMENTS.brightness
    && params.contrast === IDENTITY_ADJUSTMENTS.contrast
    && params.saturation === IDENTITY_ADJUSTMENTS.saturation
}

export function adjustmentsToCanvasFilter(params: AdjustmentsParams): string {
  assertAdjustmentsParams(params)
  if (isIdentityAdjustments(params)) return ''
  return [
    `brightness(${1 + params.brightness / 100})`,
    `contrast(${1 + params.contrast / 100})`,
    `saturate(${1 + params.saturation / 100})`,
  ].join(' ')
}
